/*
 * COPYRIGHT 2016 Jobvite, Inc. All rights reserved. This copyright notice is Copyright Management
 * Information under 17 USC 1202 and is included to protect this work and deter copyright infringement.
 * Removal or alteration of this Copyright Management Information without the express written permission
 * of Jobvite, Inc. is prohibited, and any such unauthorized removal or alteration will be a violation of
 * federal law.
 */
var JV = window.JV || {};

// utility class for broadcasting messages from jQuery code to Angular code
JV.AngularUtils = {
    cache: {},
    scope: function() {
        if (!this.cache['scope']) {
            this.cache['scope'] = $('body').scope();
        }
        return this.cache['scope'];
    },
    broadcast: function(broadcastName, args, args2) {
        var me = this;
        this.scope().$apply(function() {
            me.scope().$broadcast(broadcastName, args, args2);
        });
    },
    attachListeners: function(listenerName, callback) {
        var me = this;
        this.scope().$apply(function() {
            var deregister = me.scope().$on(listenerName, function(event, result, result2) {
                // cancel the listener before you trigger the callback so
                // it doesn't get called again for some other broadcast.
                deregister();
                callback(event, result, result2);
            });
        });
    },
    attachListenersWithoutDeregister: function(listenerName, callback) {
        var me = this;
        this.scope().$apply(function() {
            me.scope().$on(listenerName, function(event, result) {
                callback(event, result);
            });
        });
    },
    /*
        VA: removes all the previous listeners attached with the same name.
    */
    removeAllPreviousListeners: function(eventName) {
        this.scope().$$listeners[eventName] = [];
    }
};

JV.QuickViewUtils = {
    showQuickViewLoading: function() {
        $('#jv-quickViewLoadingStateWrapper').removeClass('jv-hide').addClass('jv-show');
    },
    hideQuickViewLoading: function() {
        $('#jv-quickViewLoadingStateWrapper').removeClass('jv-show').addClass('jv-hide');
    }
};
